var _path, _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoXing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H172C176.142 0.5 179.5 3.85786 179.5 8V82C179.5 86.1421 176.142 89.5 172 89.5H8C3.85786 89.5 0.5 86.1421 0.5 82V8Z",
    stroke: "#F3F0E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_972_678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_972_678)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3179 33.542L31.774 41.3435L25.1113 52.8525H33.0553L39.6734 41.3435L35.2174 33.542H27.3179Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9686 26.333L38.1187 48.7858L46.4044 63.6663H54.4692L46.0515 48.7858L58.8999 26.333H50.9686Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.699 29.9367L79.3204 39.5425L84.3805 29.9367H90.9812L82.8846 44.3682L91.2896 60.0606H84.3805L79.1884 49.5409L74.0392 60.0606H67.394L75.4032 44.4545L67.747 29.9351H74.7005L74.699 29.9367ZM95.0033 60.0606H101.427V29.9367H95.0033V60.0606ZM154.889 42.768H144.273V47.9674H149.01V54.511C147.913 54.9444 146.948 55.1172 145.809 55.1172C140.939 55.1172 138.92 51.5211 138.92 45.1078C138.92 39.1279 140.675 34.7938 146.422 34.7938C148.352 34.7938 150.457 35.3136 152.52 36.2228L154.363 31.4128C151.819 30.1126 149.055 29.5488 146.16 29.5488C136.728 29.5488 132.561 35.3984 132.561 45.0622C132.561 54.7261 136.553 60.4453 145.81 60.4453C148.792 60.4453 151.819 59.8392 154.891 58.4086V42.7648L154.889 42.768ZM112.37 29.9367H106.957V60.0606H113.206V43.0208L123.503 60.0606H128.739V29.9367H122.49V46.9765L112.37 29.9367Z",
    fill: "#F3F0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.778,
    height: 37.3333,
    fill: "white",
    transform: "translate(25.1113 26.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoXing);
export default __webpack_public_path__ + "static/media/kundenlogo-xing.104859b1a651653844a4bacdf4eaafe6.svg";
export { ForwardRef as ReactComponent };